import axios, { AxiosResponse } from 'axios';

export interface ServerResponse<T> {
    success: boolean;
    errors: string[];
    warnings: any[];
    result: T;
}

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
});

export function updateAuthHeader(token: string): void {
    axiosInstance.defaults.headers.common.Authorization = token;
}

export async function request<T>(action: string, payload: any = {}) {
    return axiosInstance.post(action, payload).then((response: AxiosResponse<ServerResponse<T>>) => {
        if (response.data.success) {
            return response.data.result;
        } else {
            throw new Error(response.data.errors[0]);
        }
    });
}